import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { abodeTheme } from './theme';

import App from './App.vue';
import { router } from './router';
import { onUnauthorized } from './api/client';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';

import 'primeicons/primeicons.css';
import './assets/main.css';

const app = createApp(App);

app.use(createPinia());
useThemeStore();
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: abodeTheme,
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
  ripple: true,
});
app.use(ToastService);
app.use(ConfirmationService);

onUnauthorized(() => {
  const auth = useAuthStore();
  auth.reset();
  if (router.currentRoute.value.name !== 'login') {
    router.push({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    });
  }
});

app.mount('#app');
